import combineSectionReducers from "combine-section-reducers";
import { UiState } from "./ui";
import { daysReducer } from "./days";
import { userReducer } from "./user";
import { DataState } from "./data";
import { Action } from "../actions";
import { currentDayReducer } from "./currentDay";
import { isCalendarOpenReducer } from "./isCalendarOpen";
import { weekVisibleReducer } from "./weekVisible";
import { syncReducer } from "./sync";
import { syncStatusReducer } from "./syncStatus";
import { isLogInOpenReducer } from "./isLogInOpen";

export type State = {
    ui: UiState;
    data: DataState;
};

export const reducer = combineSectionReducers<State, Action>({
    data: combineSectionReducers<DataState, Action, State>({
        days: daysReducer,
        user: userReducer,
        sync: syncReducer,
    }),
    ui: combineSectionReducers<UiState, Action, State>({
        syncStatus: syncStatusReducer,
        currentDay: currentDayReducer,
        isCalendarOpen: isCalendarOpenReducer,
        weekVisible: weekVisibleReducer,
        isLogInOpen: isLogInOpenReducer,
    }),
});
